import { FortuneTeller } from "../../../types";

const status = {
  待機中: "待機中",
  鑑定中: "鑑定中",
  受付中: "受付中",
  一時停止中: "一時停止中",
  NoLabel: "NoLabel",
} as const;

type Status = typeof status[keyof typeof status];

export const useChatStatus = (fortuneTeller: FortuneTeller) => {
  let chatStatus: Status = status.NoLabel;
  let telStatus: Exclude<Status, "鑑定中"> = status.NoLabel;

  const isBusy = fortuneTeller?.isBusy;
  const havePublishedChat = fortuneTeller?.havePublishedChat;
  const chatAcceptFlag = fortuneTeller?.chatAcceptFlag;
  const waitingFlag = fortuneTeller?.waitingFlag;
  const havePublishedTel = fortuneTeller?.havePublishedTel;
  const telAcceptFlag = fortuneTeller?.telAcceptFlag;
  const telWaitingFlag = fortuneTeller?.telWaitingFlag;

  if (!havePublishedChat) chatStatus = status.NoLabel;
  if (havePublishedChat && isBusy) chatStatus = status.鑑定中;
  if (havePublishedChat && !isBusy && !chatAcceptFlag)
    chatStatus = status.一時停止中;
  if (havePublishedChat && !isBusy && chatAcceptFlag && waitingFlag)
    chatStatus = status.待機中;
  if (havePublishedChat && !isBusy && chatAcceptFlag && !waitingFlag)
    chatStatus = status.受付中;

  if (!havePublishedTel) telStatus = status.NoLabel;
  if (havePublishedTel && !telAcceptFlag) telStatus = status.一時停止中;
  if (havePublishedTel && telAcceptFlag && telWaitingFlag)
    telStatus = status.待機中;
  if (havePublishedTel && telAcceptFlag && !telWaitingFlag)
    telStatus = status.受付中;

  return { chatStatus, telStatus };
};
